// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"74139d69","779":"f609eba2","872":"6c47cb43"}[chunkId] + ".chunk.js";
};